import { Koi } from '@ksyos/koi';
import type { InputField, Section } from '@common/formEngine/formEngine.types';
import { HardwareProcessStatus } from '@common/enums/hardwareProcessStatus';
import { RecorderType } from '@common/enums/recorderType';

export type HolterConfigureData = {
    configurationDatetime?: string;
    desktopProcessId?: string;
    hasDesktopProcessTimedOut?: boolean;
    holterPublicKey?: string;
    holterSerialNumber?: string;
    holterToken?: string;
    isMissingKsyosUrlHandler?: boolean;
    isProcessing: boolean;
    preparationValue?: string;
    processError: string | null;
    processStatus: HardwareProcessStatus;
    recorderType?: RecorderType;
};
const textInputFields = [
    'configurationDatetime',
    'desktopProcessId',
    'holterPublicKey',
    'holterSerialNumber',
    'holterToken',
    'preparationValue',
    'processError',
].map(
    (field) =>
        ({
            isReadonly: true,
            key: field,
            label: field,
            type: 'textInput',
        }) as InputField<HolterConfigureData, undefined>
);

const booleanFields = ['hasDesktopProcessTimedOut', 'isMissingKsyosUrlHandler', 'isProcessing'].map(
    (field) =>
        ({
            isReadonly: true,
            key: field,
            label: field,
            type: 'boolean',
        }) as InputField<HolterConfigureData, undefined>
);

export const holterConfigureSections: Section<HolterConfigureData>[] = [
    {
        fields: [
            ...textInputFields,
            ...booleanFields,
            {
                draftSchema: Koi.koi().enum(HardwareProcessStatus).optional().allow(null),
                finalSchema: Koi.koi().enum(HardwareProcessStatus).optional().allow(null),
                isReadonly: true,
                key: 'processStatus',
                label: 'processStatus',
                type: 'textInput',
            },
            {
                draftSchema: Koi.koi().enum(RecorderType).optional().allow(null),
                finalSchema: Koi.koi().enum(RecorderType).optional().allow(null),
                isReadonly: true,
                key: 'recorderType',
                label: 'recorderType',
                type: 'textInput',
            },
        ],
    },
];
